/* eslint-disable import/prefer-default-export */
export const studioIsKo = studio => (
  (studio.status[0] && studio.status[0].state === 'ko') ||
  !studio.sensor.length ||
  studio.sensor[0].state === 'ko'
);



// WEBPACK FOOTER //
// src/utils/utils.js